import { render, staticRenderFns } from "./PharmacyList.vue?vue&type=template&id=236a7307&scoped=true&lang=pug"
import script from "./PharmacyList.vue?vue&type=script&lang=js"
export * from "./PharmacyList.vue?vue&type=script&lang=js"
import style0 from "./PharmacyList.vue?vue&type=style&index=0&id=236a7307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a7307",
  null
  
)

export default component.exports